import React from "react"

function IconChatPlus({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chat-plus"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chat-plus"
      {...props}
    >
      <path
        d="M20.183 2.89c.825 0 1.504.631 1.58 1.436l.008.153V21.66c0 .57-.666.852-1.075.502l-.074-.073-3.056-3.52H3.934a1.59 1.59 0 0 1-1.56-1.288l-.021-.149-.008-.153v-12.5c0-.825.631-1.504 1.436-1.58l.153-.008h16.249zm0 1.31H3.933a.28.28 0 0 0-.271.215l-.008.064v12.5c0 .133.093.245.216.274l.064.007h13.93c.152 0 .298.053.414.147l.08.079 2.103 2.42.001-15.427a.28.28 0 0 0-.146-.245l-.07-.027-.063-.007zm-8.11 2.273c.325 0 .595.237.646.548l.008.106v2.91h2.91a.655.655 0 0 1 .106 1.3l-.107.008h-2.91l.001 2.91a.655.655 0 0 1-1.3.106l-.009-.106v-2.91H8.508a.655.655 0 0 1-.106-1.3l.106-.009h2.908l.001-2.909c0-.361.293-.654.655-.654z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChatPlus
